<template>
    <div class="main">
        <div class="login">
            <div class="logo"></div>
            <!--普通邀请-->
            <div class="normal_invite" v-show="live_id==0">
                <div class="n_img">
                    <img :src="avater"/>
                </div>
                <div class="triangle"></div>
                <div class="welcome">邀请你加入爱股票-注册领新人红包！</div>
            </div>
            <!--老师页面邀请-->
            <div class="advisor_invite" v-show="live_id!==0">
                <div class="invite">推荐你加入Ta的会员~注册领新人红包！</div>
                <div class="teacher">
                    <div class="t_img">
                        <img :src="avater"/>
                    </div>
                    <div class="t_intro">
                        <div class="t_title">
                            <span>{{name}}</span>
                            <img v-show="live_is_service_vip=='yes'" src="https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/v.png" />
                            <img v-show="live_is_teacher=='yes'" src="https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/a.png" />
                            <img v-show="is_column=='yes'" src="https://cdncos.aigupiao.com/assets/pc/img/blue_v.png" />
                            <img v-show="live_is_official=='yes'" src="https://cdncos.aigupiao.com/assets/pc/img/v_column.png" />
                        </div>
                        <div class="t_word">{{brief}}</div>
                    </div>
                </div>
            </div>
            <!--登录框-->
            <div class="login_box">
                <div class="phone" @click="inputClicked">
                    <input placeholder="输入手机号码" type="number" v-model="phone" ref="phoneInput" />
                </div>
                <div class="code">
                    <div @click="inputClicked2" class="input_box"><input placeholder="输入验证码" type="number" v-model="code" ref="phoneInput2"/></div>
                    <div class="get_code" v-if="send_status == 0" @click="get_code">获取验证码</div>
                    <div class="get_code resend" v-if="send_status == 1">{{count}}s后重新发送</div>
                    <div class="get_code" v-if="send_status == 2" @click="get_code">重新发送</div>
                </div>
                <div class="btn" @click="get_gift">领取礼包</div>
                <div class="or">
                    <div class="or_line"></div>
                    <span>或</span>
                    <div class="or_line"></div>
                </div>
                <div class="wx_login" @click="wx_login">
                    <img src="https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_wechat.png"/>
                    <span>微信登录领取礼包</span>
                </div>
                <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" target="_blank" class="download">
                   <img src="https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_down.png"/>
                    <span>下载APP</span>
                </a>
            </div>
            <div class="ftips">
              请先领取红包后再登录app即算邀请注册，若未领取红包直接下载app并注册无法获得邀请奖励。
            </div>
        </div>
        <!--领取礼物-->
        <div class="gift_wrap" v-if="result==1">
            <div class="gift_box">
                <div class="gift_word">领取成功！</div>
                <div class="gift_content">
                    <div class="gold">
                        <div class="g_img"></div>
                        <div class="g_word">金币*100</div>
                    </div>
                    <div class="coupon">
                        <div class="g_img"></div>
                        <div class="g_word">9折优惠券*1</div>
                    </div>
                </div>
                <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" target="_blank" class="g_btn">
                    <img src="https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_down.png" />
                    <span>下载APP前往查看</span>
                </a>
            </div>
            <div class="gift_close" @click="close"></div>
        </div>
        <!--提示-->
        <transition name="fade">
            <div class="tip_wrap" v-if="result==-1">
                <div class="tip">
                    <p>{{fail_reason}}</p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import '@/utils/flexible'
import * as utils from "@/utils/index";
import * as Api from "@/api/activity/wx_share.js";
export default {
    name: 'inviteCashBackShare',
    data() {
        return {
            share_id:this.$route.path.substring(33),//路由给的参数  share_id
            live_id:0,//老师邀请标识，0为普通邀请
            result:0,//提示标识，1领取成功，-1显示提示，默认0
            phone:'',//手机号
            code:'',//验证码
            inviter_id:0,//邀请人id
            live_is_service_vip:'no',//黄v
            live_is_teacher:'no',//皇冠
            live_is_official:'no',//蓝v
            is_column:'no',//专栏
            avater:'',//头像
            name:'',//昵称
            brief:'',//简介
            fail_reason:'此红包是新人专享，您是老用户不能领取。',//发送验证码的信息
            wx_login_url:'',//微信登录授权跳转地址，微信登录为后端操作
            send_status:0,//验证码发送状态 默认0，发送中1，重新发送2
            count:60,//倒计时
            time:'',
        };
    },
    created(){
        this.get_info();//获取用户数据，微信分享数据，微信登录授权数据
    },
    methods: {
        get_info(){
            Api.info({
                params:{
                    share_id:this.share_id,
                }
            })
                .then(res => {
                    utils.logic(res,data=>{
                        //console.log(data)
                        this.live_id = data.live_id;
                        if(data.live_id == 0 ){
                            this.avater = data.avatar;
                        }else{
                            //分享老师时
                            this.avater = data.live_avatar;
                            this.name = data.live_name;
                            this.brief = data.live_introduce;
                            this.live_is_service_vip = data.live_is_service_vip;
                            this.live_is_teacher = data.live_is_teacher;
                            this.live_is_official = data.live_is_official;
                            this.is_column = data.is_column;
                        }
                        //微信登录授权地址
                        this.wx_login_url = data.redirect_url;
                        //console.log(this.wx_login_url)
                        //分享到h5的数据
                        this.inviter_id = data.inviter_id;
                        let share_obj={
                            share_open :data.share_open,
                            share_logo : data.share_logo,
                            share_link : data.share_url,
                            share_content : data.share_body,
                            share_title : data.share_title,
                        }
                        console.log(share_obj)
                        this.$share(share_obj);
                        this.get_wxcode()//若为微信登录
                    });
                })
                .catch(err=>{
                    console.log(err)
                })
        },
        send_time(){
            clearInterval(this.time);
            this.send_status = 1;
            this.count = 60;
            this.time = setInterval(()=>{
                this.count--;
                if(this.count <= 0){
                    this.send_status = 2;
                }
            },1000)
        },
        get_code(){
            if(!this.phone){
                alert("请填写手机号！")
            }else if(!/^1[3456789]\d{9}$/.test(this.phone)){
                alert("请填写正确的手机号！")
            }else{
                //发送验证码
                Api.code({
                    params:{
                        mobile:this.phone,
                        inviter_id:this.inviter_id,
                    }
                })
                    .then(res => {
                        //console.log(res.data);
                        if(res.data.status == 'success'){
                            this.send_time();
                        }else{
                        }
                        this.fail_reason = res.data.message;
                        this.result = -1;
                        setTimeout(()=>{
                            this.result = 0;
                        },1200)
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        },
        get_gift(){
            //验证登录
            if(!this.phone||!this.code){
                alert("请先登录！")
            }else{
                //手机号验证登录后领取礼包
                Api.phoneLogin({
                    params:{
                        mobile:this.phone,
                        verify_code:this.code,
                        inviter_id:this.inviter_id,
                        live_id:this.live_id,
                    }
                })
                    .then(res => {
                        if(res.data.status == "success"){
                            this.result = 1;
                        }else{
                            alert(res.data.message)
                        }
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        },
        wx_login(){
            if(this.wx_login_url){
                console.log('wx_login')
                window.location.href = this.wx_login_url;
            }
        },
        close(){
            this.result = 0;
        },
        //获取地址的参数
        getUrlParam(name){
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            let r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            }
            return null;
        },
        get_wxcode(){
            let code = this.getUrlParam("code");
            console.log(code,this.inviter_id,this.live_id)
            if (code == null || code === "") {
                console.log('not wx login')//不存在就说明没有授权登录
            }else{
                // 授权登录： 验证后直接领取礼包
                Api.wechatLogin({
                    params:{
                        code:code,
                        inviter_id:this.inviter_id,
                        live_id:this.live_id,
                    }
                })
                    .then(res => {
                        if(res.data.status == "success"){
                            this.result = 1;
                        }else{
                            alert(res.data.message)
                        }
                    })
                    .catch(err=>{
                        console.log(err)
                    })
                }

        },
        inputClicked(){
            if (this.$refs.phoneInput) {
                this.$refs.phoneInput.focus();
            }
        },
        inputClicked2(){
            if (this.$refs.phoneInput2) {
                this.$refs.phoneInput2.focus();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";

    .main{
        min-height: 100vh;
        background: linear-gradient(90deg, #FF7130 0%, #FF9C29 100%);
        font-family: PingFangSC-Medium, PingFang SC;
    }
    .login{
        width: 100%;
        // height: rem(1490px);
        background-image: url("https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_bg2.png");
        background-repeat: no-repeat;
        background-size: contain;
        border-top: 1px solid transparent;
    }

    .logo{
        width: rem(466px);
        height: rem(52px);
        margin-left: rem(42px);
        margin-top: rem(30px);
        background: url("../../../assets/images/2111251418.png") no-repeat;
        background-size: contain;
    }
    .n_img{
        width: rem(100px);
        height: rem(100px);
        border-radius: 50%;
        border: rem(3px) solid #F4B56F;
        margin: rem(40px) auto rem(23px);
        img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }

    .triangle{
        width: rem(22px);
        height: rem(11px);
        background: url("https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_th.png") no-repeat;
        background-size: contain;
        margin: 0 auto;
    }

    .welcome{
        width: rem(660px);
        height: rem(89px);
        background: #FFDEBB;
        border-radius: rem(45px);
        font-size: rem(30px);
        font-weight: 600;
        color: #FF781E;
        line-height: rem(89px);
        text-align: center;
        margin: 0 auto rem(293px);
    }


    .invite{
        width: rem(540px);
        height: rem(36px);
        font-size: rem(30px);
        font-weight: 600;
        color: #FFE5C8;
        line-height: rem(36px);
        text-align: center;
        margin: rem(44px) auto rem(34px);
    }

    .teacher{
        width: rem(614px);
        height: rem(84px);
        background: url("https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_teacher.png") no-repeat;
        background-size: contain;
        margin: 0 auto rem(298px);
        padding: rem(30px);
        display: flex;

        font-size: rem(24px);
        font-weight: 400;
        color: #9B631E;
        line-height: rem(36px);

        .t_img{
            width: rem(84px);
            height: rem(84px);
            border: rem(2px) solid #F4B56F;
            border-radius: 50%;
            margin-right: rem(16px);
            img{
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        .t_intro{
            margin-top: rem(3px);
        }

        .t_title{
            font-size: rem(30px);
            font-weight: 600;
            margin-bottom: rem(7px);
            span{
                margin-right: rem(10px);
            }
            img{
                width: rem(28px);
                height: rem(28px);
                margin-right: rem(7px);
            }
        }

        .t_word{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: rem(505px);
        }
    }

    .login_box{
        width: rem(690px);
        height: rem(779px);
        background: #FFF2E3;
        border-radius: rem(20px);
        border: rem(8px) solid #FDA906;
        margin: 0 auto;
    }

    .ftips{
      width: rem(690px);
      height: rem(72px);
      font-size: rem(26px);
      font-weight: 400;
      color: #FFE3CD;
      line-height: rem(36px);
      padding: rem(30px);
    }


    ::-webkit-input-placeholder { color:#C7A07C; }
    ::-moz-placeholder { color:#C7A07C; } /* firefox 19+ */
    :-ms-input-placeholder { color:#C7A07C; } /* ie */
    input:-moz-placeholder { color:#C7A07C; }

    .phone {
        font-size: rem(30px);
        font-weight: 400;
        color: #C7A07C;
        line-height: rem(98px);
        margin: rem(56px) auto rem(34px);
        width: rem(590px);

        input{
            padding-left: 6%;
            width: 94%;
            height: rem(98px);
            background: #F5E9D2;
            border-radius: rem(10px);
            color: #C7A07C;
            display: block;
            outline: none;
        }
    }

    .code{
        width: rem(590px);
        height: rem(98px);
        border-radius: rem(10px);
        display: flex;

        font-size: rem(30px);
        font-weight: 400;
        color: #FFF2E3;
        line-height: rem(98px);
        margin: 0 auto rem(36px);

        .input_box{
            width: 63%;
        }

        input{
            padding-left: 9%;
            width: 91%;
            display: block;
            background: #F5E9D2;
            color: #C7A07C;
            outline: none;
            line-height: rem(98px);
        }

        .get_code{
            background: linear-gradient(180deg, #FFC769 0%, #F6A30C 100%);
            width: 37%;
            text-align: center;
        }
        .resend{
            font-size: rem(28px);
            color: #FFE1BE;
        }

    }

    .or{
        display: flex;
        height: rem(42px);
        width: rem(590px);
        font-size: rem(30px);
        font-weight: 400;
        color: #D49256;
        line-height: rem(42px);
        align-items: center;
        margin: 0 auto;
        span{
            margin: 0 rem(30px);
        }

    }

    .or_line{
        width: rem(249px);
        height: rem(1px);
        background: #FDA906;
    }


    .btn{

        width: rem(590px);
        height: rem(88px);
        background: linear-gradient(180deg, #FF8C57 0%, #FF4D21 100%);
        box-shadow: 0 rem(4px) rem(10px) 0 rgba(206, 69, 41, 0.3);
        border-radius: rem(10px);
        text-align: center;
        margin: 0 auto rem(34px);
    }

    .btn,.wx_login,.download{
        font-size: rem(30px);
        font-weight: rem(400px);
        color: #FFFFFF;
        line-height: rem(88px);
    }


    .wx_login,.download{
        width: rem(590px);
        height: rem(88px);
        box-shadow: 0 rem(4px) rem(10px) 0 rgba(206, 69, 41, 0.3);
        border-radius: rem(10px);
        background: linear-gradient(180deg, #FFC769 0%, #F6A30C 100%);
        margin: 19px auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .wx_login{
        img{
            width: rem(36px);
            height: rem(30px);
            margin-right: rem(14px);
        }
    }

    .download{
        margin-top: rem(27px);
        img{
            width: rem(26px);
            height: rem(24px);
            margin-right: rem(12px);
        }
    }


    .gift_wrap{
        position: absolute;
        width: 100%;
        top: 0;
        background: rgba(0, 0, 0, 0.4);
        overflow: hidden;
        height: rem(1490px);

        .gift_box{
            width: rem(690px);
            height: rem(488px);
            background: #FFF2E3;
            border-radius: rem(20px);
            border: rem(8px) solid #FDA906;
            margin: rem(495px) auto rem(43px);

            .gift_word{
                width: rem(378px);
                height: rem(78px);
                background: url("https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_sucsess_label.png") no-repeat;
                background-size: contain;
                margin: rem(-18px) auto 0;
                font-size: rem(30px);
                font-weight: 600;
                color: #C16512;
                line-height: rem(78px);
                text-align: center;
            }
            .gift_content{
                display: flex;
                margin-top: rem(27px);
                align-items: flex-end;
                .g_word{
                    height: rem(37px);
                    font-size: rem(26px);
                    font-weight: 400;
                    color: #C16512;
                    line-height: rem(37px);
                    text-align: center;
                }
                .gold{
                    margin: 0 rem(130px) 0 rem(66px);
                    .g_img{
                        width: rem(196px);
                        height: rem(150px);
                        background: url("https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_gold.png") no-repeat;
                        background-size: contain;
                        margin-bottom: rem(16px);
                    }
                }
                .coupon{
                    .g_img{
                        width: rem(213px);
                        height: rem(115px);
                        background: url("https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_coupon.png") no-repeat;
                        background-size: contain;
                        margin-bottom: rem(31px);
                    }
                }
            }

            .g_btn{
                width: rem(590px);
                height: rem(88px);
                background: linear-gradient(180deg, #FFC769 0%, #F6A30C 100%);
                box-shadow: 0px rem(4px) rem(10px) 0px rgba(206, 69, 41, 0.3);
                border-radius: rem(10px);
                margin: rem(64px) auto;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: rem(30px);
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: rem(88px);
                img{
                    width: rem(26px);
                    height: rem(24px);
                    margin-right: rem(12px);
                }
            }

        }
        .gift_close{
            width: rem(76px);
            height: rem(76px);
            background: url("https://cdncos.aigupiao.com/assets/wap/img/hd/wx_share/s_close.png") no-repeat;
            background-size: contain;
            margin: 0 auto;
        }
    }

    .tip_wrap{
        position: absolute;
        width: 100%;
        top: 0;
        overflow: hidden;
        height: rem(1490px);
        .tip{
            width: rem(510px);
            height: rem(180px);
            background: rgba(60, 60, 60, 0.9);
            border-radius: rem(20px);
            margin: rem(611px) auto 0;
            display: flex;
            justify-content: center;
            align-items: center;

            font-size: rem(30px);
            font-weight: 400;
            color: #FFFFFF;
            line-height: rem(42px);
            p{
                width: rem(450px);
            }
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

</style>